module.exports = __webpack_public_path__ + "img/mii-brawler-min.93a526f6.png";